export const getWebFontsAsText = (): string => {
  const styleSheets = Array.from(document.styleSheets);
  const styleRules = styleSheets
    .map((sheet: CSSStyleSheet) => {
      if (sheet.href) {
        return [] as CSSRule[];
      }
      return sheet.cssRules || sheet.rules || ([] as CSSRule[]);
    })
    .map((rule) => Array.from(rule))
    .reduce((acc, val) => {
      acc.push(...val);
      return acc;
    }, [] as CSSRule[])
    .filter((rule) => rule.constructor.name === 'CSSFontFaceRule')
    .map((rule: CSSFontFaceRule) => rule?.cssText || '')
    .map((ruleText: string) => ruleText.replace('}', ';font-display: swap; $&'));

  return styleRules.join('\n');
};
